/* 管理端模拟数据（与用户侧字段对齐，按"管理视角"补充平台操作所需字段） */

/* ============ 供应商档案（列表用精简，详情用全量） ============ */
export const vendors = [
  { id: 1, name: '江苏佳诺云电子科技有限公司', code: 'V2026001', type: '供应商', status: '有效', auditStatus: '已通过', contactName: '张经理', contactMobile: '13800138000', projectCount: 3, createTime: '2026-01-15 10:23:00' },
  { id: 2, name: '兰维乐（上海）食品有限公司', code: 'V2026002', type: '服务商', status: '有效', auditStatus: '已通过', contactName: '李经理', contactMobile: '13900139000', projectCount: 2, createTime: '2026-02-08 14:11:00' },
  { id: 3, name: '上海晨光科力普办公用品有限公司', code: 'V2026003', type: '供应商', status: '待审核', auditStatus: '待审核', contactName: '王经理', contactMobile: '13700137000', projectCount: 0, createTime: '2026-07-20 09:45:00' },
  { id: 4, name: '得力集团有限公司', code: 'V2026004', type: '供应商', status: '有效', auditStatus: '已通过', contactName: '赵经理', contactMobile: '13600136000', projectCount: 5, createTime: '2025-11-30 16:50:00' },
  { id: 5, name: '深圳齐心集团股份有限公司', code: 'V2026005', type: '供应商', status: '冻结', auditStatus: '已通过', contactName: '陈经理', contactMobile: '13500135000', projectCount: 1, createTime: '2026-03-12 11:18:00' },
]

/* 供应商全量档案（管理视角）：与用户侧 vendor/detail 字段对齐，并补充平台治理字段 */
export const vendorDetails = {
  1: {
    id: 1, name: '江苏佳诺云电子科技有限公司', shortName: '佳诺云', code: 'V2026001', type: '供应商',
    status: '有效', auditStatus: '已通过', tin: '91320000MA1XXXXXXX', createTime: '2026-01-15 10:23:00',
    logo: '', licenseImage: '', licenseStart: '2024-01-01', licenseEnd: '2034-01-01', licensePermanent: false,
    cooperationCategory: '办公设备、电子耗材、MRO 工业品', brands: '佳诺云、得力',
    legalName: '张三', legalIdNo: '3201XXXXXXXXXX1234', idCardStart: '2018-05-01', idCardEnd: '2038-05-01', idCardPermanent: false,
    defaultContact: { name: '张经理', mobile: '13800138000', email: 'zhang@jianuoyun.com' },
    projectContact: { name: '张经理', mobile: '13800138000', email: 'zhang@jianuoyun.com' },
    orderContact: { name: '李调度', mobile: '13800138001', email: 'order@jianuoyun.com' },
    financeContact: { name: '王财务', mobile: '13800138002', email: 'finance@jianuoyun.com' },
    serviceContact: { name: '赵客服', mobile: '13800138003', email: 'service@jianuoyun.com' },
    logisticsContact: { name: '陈物流', mobile: '13800138004', email: 'wl@jianuoyun.com' },
    invoiceCompanyName: '江苏佳诺云电子科技有限公司', invoiceTaxNo: '91320000MA1XXXXXXX',
    taxpayerType: '0', invoiceRegAddress: '江苏省南京市江宁区秣陵街道XX号', invoiceRegPhone: '025-88889999',
    invoiceBankName: '工商银行南京江宁支行', invoiceBankAccount: '6222000000000001', invoiceScanFile: '',
    warehouseArea: 5200, transportVehicles: 12, customerService: 30, expressLogistics: '顺丰、京东、中通',
    warehouseCertUrl: '', logisticsCertUrl: '', accountLicenseUrl: '', taxpayerQualificationUrl: '',
    bankName: '工商银行南京江宁支行', bankSubBranchName: '江宁科学园支行', bankCode: '102301000000',
    bankAccountName: '江苏佳诺云电子科技有限公司', bankAccount: '6222000000000001',
    returnFullAddress: '江苏省南京市江宁区秣陵街道XX号仓库A栋', returnContacts: '陈物流', returnContactsMobile: '13800138004',
    shipFullAddress: '江苏省南京市江宁区秣陵街道XX号仓库B栋', shipContacts: '陈物流', shipContactsMobile: '13800138004',
    lastTaxPayCertificate: '', signQualificationsSummary: '',
    updateReason: '', attestFile: '',
  },
  2: {
    id: 2, name: '兰维乐（上海）食品有限公司', shortName: '兰维乐', code: 'V2026002', type: '服务商',
    status: '有效', auditStatus: '已通过', tin: '91310000MA1YYYYYYY', createTime: '2026-02-08 14:11:00',
    logo: '', licenseImage: '', licenseStart: '2023-06-01', licenseEnd: '2033-06-01', licensePermanent: false,
    cooperationCategory: '食品饮料、滋补养生', brands: '兰维乐',
    legalName: '李四', legalIdNo: '3101XXXXXXXXXX5678', idCardStart: '2019-03-01', idCardEnd: '2039-03-01', idCardPermanent: false,
    defaultContact: { name: '李经理', mobile: '13900139000', email: 'li@lanweile.com' },
    projectContact: { name: '李经理', mobile: '13900139000', email: 'li@lanweile.com' },
    orderContact: { name: '周调度', mobile: '13900139001', email: 'order@lanweile.com' },
    financeContact: { name: '吴财务', mobile: '13900139002', email: 'finance@lanweile.com' },
    serviceContact: { name: '郑客服', mobile: '13900139003', email: 'service@lanweile.com' },
    logisticsContact: { name: '孙物流', mobile: '13900139004', email: 'wl@lanweile.com' },
    invoiceCompanyName: '兰维乐（上海）食品有限公司', invoiceTaxNo: '91310000MA1YYYYYYY',
    taxpayerType: '0', invoiceRegAddress: '上海市浦东新区张江高科技园区XX路XX号', invoiceRegPhone: '021-66667777',
    invoiceBankName: '招商银行上海张江支行', invoiceBankAccount: '6225888800000002', invoiceScanFile: '',
    warehouseArea: 8600, transportVehicles: 20, customerService: 45, expressLogistics: '顺丰冷链、京东冷链',
    warehouseCertUrl: '', logisticsCertUrl: '', accountLicenseUrl: '', taxpayerQualificationUrl: '',
    bankName: '招商银行上海张江支行', bankSubBranchName: '张江高科支行', bankCode: '308290000000',
    bankAccountName: '兰维乐（上海）食品有限公司', bankAccount: '6225888800000002',
    returnFullAddress: '上海市浦东新区张江高科技园区XX路XX号冷库', returnContacts: '孙物流', returnContactsMobile: '13900139004',
    shipFullAddress: '上海市浦东新区张江高科技园区XX路XX号仓库', shipContacts: '孙物流', shipContactsMobile: '13900139004',
    lastTaxPayCertificate: '', signQualificationsSummary: '',
    updateReason: '', attestFile: '',
  },
  3: {
    id: 3, name: '上海晨光科力普办公用品有限公司', shortName: '科力普', code: 'V2026003', type: '供应商',
    status: '待审核', auditStatus: '待审核', tin: '91310000MA3ZZZZZZZ', createTime: '2026-07-20 09:45:00',
    logo: '', licenseImage: '', licenseStart: '2025-01-01', licenseEnd: '2035-01-01', licensePermanent: false,
    cooperationCategory: '办公文具、办公日用', brands: '晨光、科力普',
    legalName: '王五', legalIdNo: '3101XXXXXXXXXX9999', idCardStart: '2020-01-01', idCardEnd: '2040-01-01', idCardPermanent: false,
    defaultContact: { name: '王经理', mobile: '13700137000', email: 'wang@colipu.com' },
    projectContact: { name: '王经理', mobile: '13700137000', email: 'wang@colipu.com' },
    orderContact: { name: '冯调度', mobile: '13700137001', email: 'order@colipu.com' },
    financeContact: { name: '蒋财务', mobile: '13700137002', email: 'finance@colipu.com' },
    serviceContact: { name: '韩客服', mobile: '13700137003', email: 'service@colipu.com' },
    logisticsContact: { name: '杨物流', mobile: '13700137004', email: 'wl@colipu.com' },
    invoiceCompanyName: '上海晨光科力普办公用品有限公司', invoiceTaxNo: '91310000MA3ZZZZZZZ',
    taxpayerType: '0', invoiceRegAddress: '上海市奉贤区光明A3工业园区XX号', invoiceRegPhone: '021-55556666',
    invoiceBankName: '建设银行上海奉贤支行', invoiceBankAccount: '6227000000000003', invoiceScanFile: '',
    warehouseArea: 12000, transportVehicles: 35, customerService: 80, expressLogistics: '顺丰、德邦、安能',
    warehouseCertUrl: '', logisticsCertUrl: '', accountLicenseUrl: '', taxpayerQualificationUrl: '',
    bankName: '建设银行上海奉贤支行', bankSubBranchName: '奉贤工业园支行', bankCode: '105290000000',
    bankAccountName: '上海晨光科力普办公用品有限公司', bankAccount: '6227000000000003',
    returnFullAddress: '上海市奉贤区光明A3工业园区XX号退货仓', returnContacts: '杨物流', returnContactsMobile: '13700137004',
    shipFullAddress: '上海市奉贤区光明A3工业园区XX号发货仓', shipContacts: '杨物流', shipContactsMobile: '13700137004',
    lastTaxPayCertificate: '', signQualificationsSummary: '',
    updateReason: '', attestFile: '',
  },
  4: {
    id: 4, name: '得力集团有限公司', shortName: '得力', code: 'V2026004', type: '供应商',
    status: '有效', auditStatus: '已通过', tin: '91330200MA4AAAAAAA', createTime: '2025-11-30 16:50:00',
    logo: '', licenseImage: '', licenseStart: '2022-01-01', licenseEnd: '2032-01-01', licensePermanent: false,
    cooperationCategory: '办公文具、办公设备、MRO', brands: '得力、纽赛',
    legalName: '赵六', legalIdNo: '3302XXXXXXXXXX1111', idCardStart: '2017-01-01', idCardEnd: '2037-01-01', idCardPermanent: false,
    defaultContact: { name: '赵经理', mobile: '13600136000', email: 'zhao@deli.com' },
    projectContact: { name: '赵经理', mobile: '13600136000', email: 'zhao@deli.com' },
    orderContact: { name: '钱调度', mobile: '13600136001', email: 'order@deli.com' },
    financeContact: { name: '孙财务', mobile: '13600136002', email: 'finance@deli.com' },
    serviceContact: { name: '李客服', mobile: '13600136003', email: 'service@deli.com' },
    logisticsContact: { name: '周物流', mobile: '13600136004', email: 'wl@deli.com' },
    invoiceCompanyName: '得力集团有限公司', invoiceTaxNo: '91330200MA4AAAAAAA',
    taxpayerType: '0', invoiceRegAddress: '浙江省宁波市宁海县得力工业园', invoiceRegPhone: '0574-65558888',
    invoiceBankName: '中国银行宁海支行', invoiceBankAccount: '6226000000000004', invoiceScanFile: '',
    warehouseArea: 30000, transportVehicles: 60, customerService: 150, expressLogistics: '德邦、顺丰、京东',
    warehouseCertUrl: '', logisticsCertUrl: '', accountLicenseUrl: '', taxpayerQualificationUrl: '',
    bankName: '中国银行宁海支行', bankSubBranchName: '宁海科技支行', bankCode: '104332000000',
    bankAccountName: '得力集团有限公司', bankAccount: '6226000000000004',
    returnFullAddress: '浙江省宁波市宁海县得力工业园退货中心', returnContacts: '周物流', returnContactsMobile: '13600136004',
    shipFullAddress: '浙江省宁波市宁海县得力工业园发货中心', shipContacts: '周物流', shipContactsMobile: '13600136004',
    lastTaxPayCertificate: '', signQualificationsSummary: '',
    updateReason: '', attestFile: '',
  },
  5: {
    id: 5, name: '深圳齐心集团股份有限公司', shortName: '齐心', code: 'V2026005', type: '供应商',
    status: '冻结', auditStatus: '已通过', tin: '91440300MA5BBBBBBB', createTime: '2026-03-12 11:18:00',
    logo: '', licenseImage: '', licenseStart: '2023-03-01', licenseEnd: '2033-03-01', licensePermanent: false,
    cooperationCategory: '办公文具、办公日用', brands: '齐心、Comix',
    legalName: '陈七', legalIdNo: '4403XXXXXXXXXX2222', idCardStart: '2019-06-01', idCardEnd: '2039-06-01', idCardPermanent: false,
    defaultContact: { name: '陈经理', mobile: '13500135000', email: 'chen@comix.com' },
    projectContact: { name: '陈经理', mobile: '13500135000', email: 'chen@comix.com' },
    orderContact: { name: '卫调度', mobile: '13500135001', email: 'order@comix.com' },
    financeContact: { name: '蒋财务', mobile: '13500135002', email: 'finance@comix.com' },
    serviceContact: { name: '沈客服', mobile: '13500135003', email: 'service@comix.com' },
    logisticsContact: { name: '韩物流', mobile: '13500135004', email: 'wl@comix.com' },
    invoiceCompanyName: '深圳齐心集团股份有限公司', invoiceTaxNo: '91440300MA5BBBBBBB',
    taxpayerType: '0', invoiceRegAddress: '广东省深圳市坪山区齐心科技园', invoiceRegPhone: '0755-89999999',
    invoiceBankName: '平安银行深圳坪山支行', invoiceBankAccount: '6229800000000005', invoiceScanFile: '',
    warehouseArea: 18000, transportVehicles: 40, customerService: 90, expressLogistics: '顺丰、中通、圆通',
    warehouseCertUrl: '', logisticsCertUrl: '', accountLicenseUrl: '', taxpayerQualificationUrl: '',
    bankName: '平安银行深圳坪山支行', bankSubBranchName: '坪山支行', bankCode: '307584000000',
    bankAccountName: '深圳齐心集团股份有限公司', bankAccount: '6229800000000005',
    returnFullAddress: '广东省深圳市坪山区齐心科技园退货仓', returnContacts: '韩物流', returnContactsMobile: '13500135004',
    shipFullAddress: '广东省深圳市坪山区齐心科技园发货仓', shipContacts: '韩物流', shipContactsMobile: '13500135004',
    lastTaxPayCertificate: '', signQualificationsSummary: '',
    updateReason: '因履约异常被平台冻结', attestFile: '',
  },
}

/* 供应商关联订单（管理视角：监控全量） */
export const vendorOrders = {
  1: [
    { orderNo: 'PO202601150001', purchaser: '浦东发展银行', itemCount: 12, totalAmount: '12580.00', status: '已妥投', sla: '正常', orderTime: '2026-01-15 09:00:00' },
    { orderNo: 'PO202603100012', purchaser: '兴业银行集采', itemCount: 8, totalAmount: '8600.00', status: '已发货', sla: '正常', orderTime: '2026-03-10 11:20:00' },
  ],
  5: [
    { orderNo: 'PO202606200033', purchaser: '浦东发展银行', itemCount: 5, totalAmount: '4300.00', status: '待发货', sla: '超期', orderTime: '2026-06-20 09:00:00' },
  ],
}

/* 供应商关联对账单（管理视角） */
export const vendorBills = {
  1: [
    { billNo: 'B202601150001', billPeriod: '2026-01', orderCount: 12, totalAmount: '12580.00', status: '已确认', createTime: '2026-02-01 09:00:00' },
  ],
  5: [
    { billNo: 'B202606200033', billPeriod: '2026-06', orderCount: 5, totalAmount: '4300.00', status: '待确认', createTime: '2026-07-01 09:00:00' },
  ],
}

/* ============ 供应商信息变更审批（结构化前后对比） ============ */
export const vendorChanges = [
  {
    id: 101, vendorId: 1, vendorName: '江苏佳诺云电子科技有限公司', applyTime: '2026-07-22 10:00:00', status: '待审核',
    fields: [
      { label: '法人姓名', before: '张三', after: '张四' },
      { label: '开户银行', before: '工商银行', after: '建设银行' },
    ],
  },
  {
    id: 102, vendorId: 2, vendorName: '兰维乐（上海）食品有限公司', applyTime: '2026-07-23 14:30:00', status: '待审核',
    fields: [
      { label: '联系人姓名', before: '李经理', after: '李总' },
      { label: '退货地址', before: '上海浦东', after: '上海徐汇' },
    ],
  },
  {
    id: 103, vendorId: 5, vendorName: '深圳齐心集团股份有限公司', applyTime: '2026-07-20 09:15:00', status: '已通过',
    fields: [
      { label: '银行账户', before: '6222000000000001', after: '6222000000000002' },
    ],
  },
]

/* ============ 商品审核（全量字段，与用户侧 serviceItemList 对齐） ============ */
export const products = [
  {
    id: 1, skuId: '18607831', name: '兰维乐 矿泉水 360ml*24瓶', itemId: '18607831',
    image: 'https://cdnprod.ea380buy.com/images/40e7784d-0437-408d-aa9c-1f36c0353f79.jpg',
    category: '水', categoryPath: '食品饮料 / 水 / 饮用水', brand: '兰维乐',
    vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行', itemType: '普通商品',
    spec: '360ml*24瓶/箱', unit: '箱', price: '59.90', cost: '42.00', stock: 1200,
    auditStatus: '待审核', submitTime: '2026-07-24 10:00:00', submitter: '李经理', rejectReason: '',
  },
  {
    id: 2, skuId: '18610109', name: '兰维乐 UMF10+ 250g/瓶 蜂蜜', itemId: '18610109', image: '',
    category: '滋补养生', categoryPath: '食品饮料 / 滋补养生 / 蜂蜜', brand: '兰维乐',
    vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行', itemType: '普通商品',
    spec: '250g/瓶', unit: '瓶', price: '399.00', cost: '280.00', stock: 360,
    auditStatus: '待审核', submitTime: '2026-07-24 11:30:00', submitter: '李经理', rejectReason: '',
  },
  {
    id: 3, skuId: '18610115', name: '兰维乐 矿泉水 600ML*12瓶', itemId: '18610115', image: '',
    category: '水', categoryPath: '食品饮料 / 水 / 饮用水', brand: '兰维乐',
    vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行', itemType: '普通商品',
    spec: '600ML*12瓶/箱', unit: '箱', price: '35.90', cost: '25.00', stock: 2400,
    auditStatus: '已通过', submitTime: '2026-07-23 09:00:00', submitter: '李经理', rejectReason: '',
  },
  {
    id: 4, skuId: '20010088', name: '得力 A4 复印纸 70g 500张/包', itemId: '20010088', image: '',
    category: '办公文具', categoryPath: '办公文具 / 办公用纸 / 复印纸', brand: '得力',
    vendorName: '得力集团有限公司', projectName: '兴业银行集采', itemType: '普通商品',
    spec: '70g 500张/包', unit: '包', price: '25.00', cost: '18.50', stock: 8000,
    auditStatus: '已拒绝', submitTime: '2026-07-22 15:00:00', submitter: '赵经理', rejectReason: '商品类目与品牌授权不符，请重新选择类目后再提交。',
  },
]

/* 商品审核进度（审核工作台节点） */
export const productAuditProcess = {
  1: [
    { node: '供应商提交', time: '2026-07-24 10:00:00', operator: '李经理', status: 'done', desc: '商品信息已提交' },
    { node: '平台初审', time: '2026-07-24 14:00:00', operator: '品类运营-小王', status: 'done', desc: '资料完整，进入终审' },
    { node: '平台终审', time: '', operator: '', status: 'process', desc: '等待终审结果' },
  ],
  4: [
    { node: '供应商提交', time: '2026-07-22 15:00:00', operator: '赵经理', status: 'done', desc: '商品信息已提交' },
    { node: '平台初审', time: '2026-07-22 17:00:00', operator: '品类运营-小王', status: 'done', desc: '发现类目不符' },
    { node: '平台终审', time: '2026-07-23 09:30:00', operator: '品类运营-小王', status: 'reject', desc: '已驳回：商品类目与品牌授权不符' },
  ],
}

/* ============ 采购订单监控（全量，含商品行） ============ */
export const orders = [
  {
    id: 1, orderNo: 'PO202607240001', vendorName: '江苏佳诺云电子科技有限公司', purchaser: '浦东发展银行',
    itemCount: 12, totalAmount: '12580.00', status: '待发货', sla: '正常', orderTime: '2026-07-24 09:00:00',
    receiveInfo: '上海市浦东新区浦东南路XX号 张主任 13800001111',
    lines: [
      { skuId: '19001234', itemName: '佳诺云 无线键鼠套装 KW-200', spec: '黑色/套', price: '199.00', cost: '140.00', quantity: 12, taxRate: '13%' },
    ],
  },
  {
    id: 2, orderNo: 'PO202607240002', vendorName: '兰维乐（上海）食品有限公司', purchaser: '兴业银行集采',
    itemCount: 5, totalAmount: '3890.50', status: '已发货', sla: '正常', orderTime: '2026-07-23 14:00:00',
    receiveInfo: '上海市徐汇区虹桥路XX号 李主管 13800002222',
    logistics: '顺丰 SF1234567890 已揽收',
    lines: [
      { skuId: '18607831', itemName: '兰维乐 矿泉水 360ml*24瓶', spec: '360ml*24瓶/箱', price: '59.90', cost: '42.00', quantity: 50, taxRate: '13%' },
    ],
  },
  {
    id: 3, orderNo: 'PO202607220003', vendorName: '得力集团有限公司', purchaser: '浦东发展银行',
    itemCount: 30, totalAmount: '25600.00', status: '待发货', sla: '超期', orderTime: '2026-07-22 10:00:00',
    receiveInfo: '上海市浦东新区浦东南路XX号 王经理 13800003333',
    lines: [
      { skuId: '20010088', itemName: '得力 A4 复印纸 70g 500张/包', spec: '70g 500张/包', price: '25.00', cost: '18.50', quantity: 800, taxRate: '13%' },
    ],
  },
]

/* ============ 对账单管理（全量字段，与用户侧 supplierBillSup 对齐） ============ */
export const bills = [
  {
    id: 1, billNo: 'B202607240001', vendorName: '江苏佳诺云电子科技有限公司', billPeriod: '2026-07', orderCount: 12,
    totalAmount: '12580.00', status: '待确认', createTime: '2026-07-25 09:00:00',
    invoiceTitle: '江苏佳诺云电子科技有限公司', billType: '联采', project: '浦东发展银行', selfBuilt: '否',
    hasInvoice: '是', invoiceStatus: '发票待审核', submitDate: '2026-07-25', remark: '',
  },
  {
    id: 2, billNo: 'B202607240002', vendorName: '兰维乐（上海）食品有限公司', billPeriod: '2026-07', orderCount: 5,
    totalAmount: '3890.50', status: '已确认', createTime: '2026-07-25 08:00:00',
    invoiceTitle: '兰维乐（上海）食品有限公司', billType: '购销', project: '兴业银行集采', selfBuilt: '否',
    hasInvoice: '是', invoiceStatus: '发票审核通过', submitDate: '2026-07-25', remark: '含冷链运费',
  },
  {
    id: 3, billNo: 'B202607240003', vendorName: '得力集团有限公司', billPeriod: '2026-07', orderCount: 30,
    totalAmount: '25600.00', status: '处理中', createTime: '2026-07-24 16:00:00',
    invoiceTitle: '得力集团有限公司', billType: '联采', project: '浦东发展银行', selfBuilt: '否',
    hasInvoice: '否', invoiceStatus: '发票待审核', submitDate: '2026-07-24', remark: '',
  },
]

/* ============ 报备订单（管理视角：全平台报备单审核台，含供应商名与审核状态） ============ */
export const reportOrders = [
  {
    id: 1, reportNo: 'R202607240001', orderNo: 'PO202607200001', customerOrderNo: 'C202607200001',
    reportType: '单号报备', vendorName: '江苏佳诺云电子科技有限公司', projectName: '兴业银行集采',
    purchaseUnitName: '兴业银行股份有限公司', reportStatus: '待审核', auditStatus: '待审核',
    expiringSoon: '1', regionText: '安徽省 / 合肥市', skuId: '19001234', createTime: '2026-07-24 09:10:00',
    detail: { reportType: '单号报备', projectName: '兴业银行集采', purchaseUnitName: '兴业银行股份有限公司', regionText: '安徽省 / 合肥市', skuId: '19001234', remark: '客户预约单需平台报备关联' },
  },
  {
    id: 2, reportNo: 'R202607230002', orderNo: 'PO202607180002', customerOrderNo: 'C202607180002',
    reportType: '商品明细报备', vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行',
    purchaseUnitName: '上海浦东发展银行总行', reportStatus: '已通过', auditStatus: '已通过',
    expiringSoon: '0', regionText: '上海市 / 浦东新区', skuId: '18607831', createTime: '2026-07-23 11:00:00',
    detail: { reportType: '商品明细报备', projectName: '浦东发展银行', purchaseUnitName: '上海浦东发展银行总行', regionText: '上海市 / 浦东新区', skuId: '18607831', remark: '商品明细报备已核对' },
  },
  {
    id: 3, reportNo: 'R202607220003', orderNo: 'PO202607150003', customerOrderNo: 'C202607150003',
    reportType: '单号报备', vendorName: '得力集团有限公司', projectName: '兴业银行集采',
    purchaseUnitName: '兴业银行股份有限公司', reportStatus: '已拒绝', auditStatus: '已拒绝',
    expiringSoon: '0', regionText: '浙江省 / 宁波市', skuId: '20010088', createTime: '2026-07-22 14:30:00',
    detail: { reportType: '单号报备', projectName: '兴业银行集采', purchaseUnitName: '兴业银行股份有限公司', regionText: '浙江省 / 宁波市', skuId: '20010088', remark: '报备单号与采购订单号不匹配' },
    rejectReason: '报备单号与采购订单号不匹配，请核对后重新提交',
  },
]

/* ============ 反采申请单（管理视角：全平台反采申请审核台） ============ */
export const reverseApps = [
  {
    id: 1, applicationNo: 'F202607240001', purchaseOrderNo: 'PO202607200010', vendorName: '江苏佳诺云电子科技有限公司',
    projectName: '兴业银行集采', skuId: '19001234', skuName: '佳诺云 无线键鼠套装 KW-200', skuCode: 'LN-19001234',
    skuImage: '', applyQty: 20, confirmQty: '', reversePrice: '180.00', goodsPayable: '3600.00', totalAmount: '3600.00',
    status: '待审核', rejectReason: '', createTime: '2026-07-24 10:20:00',
    detail: { applicationNo: 'F202607240001', purchaseOrderNo: 'PO202607200010', projectName: '兴业银行集采', skuName: '佳诺云 无线键鼠套装 KW-200', applyQty: 20, reversePrice: '180.00', remark: '客户临时追加，需平台反向采购' },
  },
  {
    id: 2, applicationNo: 'F202607230002', purchaseOrderNo: 'PO202607180020', vendorName: '兰维乐（上海）食品有限公司',
    projectName: '浦东发展银行', skuId: '18607831', skuName: '兰维乐 矿泉水 360ml*24瓶', skuCode: 'LN-18607831',
    skuImage: '', applyQty: 50, confirmQty: 50, reversePrice: '45.00', goodsPayable: '2250.00', totalAmount: '2250.00',
    status: '已通过', rejectReason: '', createTime: '2026-07-23 16:40:00',
    detail: { applicationNo: 'F202607230002', purchaseOrderNo: 'PO202607180020', projectName: '浦东发展银行', skuName: '兰维乐 矿泉水 360ml*24瓶', applyQty: 50, confirmQty: 50, reversePrice: '45.00', remark: '已确认采购数量' },
  },
  {
    id: 3, applicationNo: 'F202607220003', purchaseOrderNo: 'PO202607150030', vendorName: '得力集团有限公司',
    projectName: '兴业银行集采', skuId: '20010088', skuName: '得力 A4 复印纸 70g 500张/包', skuCode: 'LN-20010088',
    skuImage: '', applyQty: 100, confirmQty: '', reversePrice: '22.00', goodsPayable: '2200.00', totalAmount: '2200.00',
    status: '已拒绝', rejectReason: '反采单价高于市场集采价，请按集采协议价重新提交', createTime: '2026-07-22 09:30:00',
    detail: { applicationNo: 'F202607220003', purchaseOrderNo: 'PO202607150030', projectName: '兴业银行集采', skuName: '得力 A4 复印纸 70g 500张/包', applyQty: 100, reversePrice: '22.00', remark: '供应商发起反采' },
  },
]

/* ============ 发货单管理（管理视角：全平台发货单与物流监控） ============ */
export const shipOrders = [
  {
    id: 1, shipId: 'S202607240001', purchaseOrderNo: 'PO202607200001', customerOrderNo: 'C202607200001',
    vendorName: '江苏佳诺云电子科技有限公司', projectName: '兴业银行集采', warehouse: '南京江宁仓',
    logisticsCompany: '顺丰速运', trackingNo: 'SF1234567890', status: '已发货', deliveredStatus: '未妥投',
    rejectStatus: '无', deliverableTime: '2026-07-26 18:00:00', deliveredTime: '',
    isUnionOrder: '否', receiver: '张主任', receiverMobile: '13800001111', receiverAddress: '上海市浦东新区浦东南路XX号',
    createTime: '2026-07-24 09:00:00', logistics: '顺丰 SF1234567890 已揽收，运输中',
  },
  {
    id: 2, shipId: 'S202607230002', purchaseOrderNo: 'PO202607180002', customerOrderNo: 'C202607180002',
    vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行', warehouse: '上海张江冷库',
    logisticsCompany: '京东冷链', trackingNo: 'JD0099887766', status: '已妥投', deliveredStatus: '已妥投',
    rejectStatus: '无', deliverableTime: '2026-07-24 12:00:00', deliveredTime: '2026-07-24 11:30:00',
    isUnionOrder: '否', receiver: '李主管', receiverMobile: '13800002222', receiverAddress: '上海市徐汇区虹桥路XX号',
    createTime: '2026-07-23 10:00:00', logistics: '京东冷链 JD0099887766 已签收',
  },
  {
    id: 3, shipId: 'S202607220003', purchaseOrderNo: 'PO202607150003', customerOrderNo: 'C202607150003',
    vendorName: '得力集团有限公司', projectName: '兴业银行集采', warehouse: '宁波宁海仓',
    logisticsCompany: '德邦快递', trackingNo: 'DB5566778899', status: '已拒收', deliveredStatus: '未妥投',
    rejectStatus: '已拒收', deliverableTime: '2026-07-23 18:00:00', deliveredTime: '',
    isUnionOrder: '是', receiver: '王经理', receiverMobile: '13800003333', receiverAddress: '上海市浦东新区浦东南路XX号',
    createTime: '2026-07-22 08:00:00', logistics: '德邦 DB5566778899 客户拒收退回',
  },
]

/* ============ 操作日志（全局审计追踪，各模块审核/治理动作均追加写入 store.logs） ============ */
export const seedLogs = [
  { id: 1, time: '2026-07-24 14:00:00', module: '商品', action: '商品初审通过', target: '兰维乐 矿泉水 360ml*24瓶', operator: '品类运营-小王', detail: '资料完整，进入终审' },
  { id: 2, time: '2026-07-23 09:30:00', module: '商品', action: '商品驳回', target: '得力 A4 复印纸 70g 500张/包', operator: '品类运营-小王', detail: '类目与品牌授权不符，已通知供应商' },
  { id: 3, time: '2026-07-23 09:00:00', module: '商品', action: '商品审核通过并上架', target: '兰维乐 矿泉水 600ML*12瓶', operator: '品类运营-小王', detail: '已上架至商品中心' },
  { id: 4, time: '2026-07-22 09:15:00', module: '供应商', action: '信息变更通过', target: '深圳齐心集团股份有限公司', operator: '平台管理员', detail: '银行账户变更 6222...0001 → 0002' },
  { id: 5, time: '2026-07-20 09:45:00', module: '供应商', action: '入驻申请提交', target: '上海晨光科力普办公用品有限公司', operator: '王经理', detail: '供应商提交入驻申请，待平台审核' },
  { id: 6, time: '2026-07-25 09:00:00', module: '财务', action: '生成对账单', target: 'B202607240001', operator: '系统', detail: '江苏佳诺云电子科技有限公司 2026-07 账期' },
  { id: 7, time: '2026-07-24 10:00:00', module: '订单', action: '订单创建', target: 'PO202607240001', operator: '浦东发展银行', detail: '采购订单创建，待供应商发货' },
]

/* ============ 资质/授权审核（管理视角，与用户侧 vendor/qualification 对齐） ============ */
export const qualifications = [
  { id: 1, vendorId: 1001, vendorName: '江苏佳诺云电子科技有限公司', certType: '品牌授权', level: '省级代理', type: '授权', category: '数码电器', brandName: '联想', categoryName: '笔记本电脑', auditStatus: '待审核', projectName: '兴业银行集采', itemId: 'I2001', startDate: '2026-01-01', endDate: '2026-12-31', submitTime: '2026-07-20 09:00:00', updateTime: '2026-07-20 09:00:00', remark: '' },
  { id: 2, vendorId: 1002, vendorName: '兰维乐（上海）食品有限公司', certType: '食品经营许可证', level: '-', type: '资质', category: '食品生鲜', brandName: '兰维乐', categoryName: '乳制品', auditStatus: '已通过', projectName: '浦东发展银行', itemId: 'I2002', startDate: '2026-03-01', endDate: '2027-02-28', submitTime: '2026-06-10 14:00:00', updateTime: '2026-06-12 10:00:00', remark: '资料齐全' },
  { id: 3, vendorId: 1003, vendorName: '得力集团有限公司', certType: '品牌授权', level: '全国总代', type: '授权', category: '办公文具', brandName: '得力', categoryName: '办公文具', auditStatus: '待审核', projectName: '兴业银行集采', itemId: 'I2003', startDate: '2026-05-01', endDate: '2027-04-30', submitTime: '2026-07-22 16:30:00', updateTime: '2026-07-22 16:30:00', remark: '' },
  { id: 4, vendorId: 1004, vendorName: '深圳齐心集团股份有限公司', certType: 'ISO9001', level: '-', type: '资质', category: '办公文具', brandName: '齐心', categoryName: '办公耗材', auditStatus: '已驳回', projectName: '浦东发展银行', itemId: 'I2004', startDate: '2026-02-01', endDate: '2027-01-31', submitTime: '2026-06-20 11:00:00', updateTime: '2026-06-21 09:00:00', remark: '证书扫描件模糊，请重新上传' },
  { id: 5, vendorId: 1005, vendorName: '上海晨光科力普办公用品有限公司', certType: '品牌授权', level: '区域代理', type: '授权', category: '办公文具', brandName: '晨光', categoryName: '书写工具', auditStatus: '已过期', projectName: '联家', itemId: 'I2005', startDate: '2025-01-01', endDate: '2025-12-31', submitTime: '2025-11-01 10:00:00', updateTime: '2025-12-31 00:00:00', remark: '授权已过期，需续签' },
]

/* ============ 合同模板库（管理端起草合同时引用） ============ */
export const contractTemplates = [
  {
    id: 1, name: '供应商合作框架协议（年度）', category: '框架协议', signType: 2, validityMonths: 12, paymentDays: 30, settleDay: 25,
    amountDesc: '按实际订单月度结算', enabled: true, updatedAt: '2026-07-10 10:00:00',
    variables: ['供应商名称', '合作项目', '有效期', '账期', '结算日'],
    content: '甲方（平台）：安徽亿佳供应链集团有限公司\n乙方（供应商）：{供应商名称}\n一、合作内容：乙方作为甲方“{合作项目}”项目的指定供应商，按甲方订单供货。\n二、合同有效期：{有效期}。\n三、结算与账期：双方按月结算，账期为 {账期} 天，每月 {结算日} 日为对账结算日。\n四、电子签署：本合同通过第三方电子签名平台（持牌CA+意愿认证+区块链存证）在线签署，与纸质盖章件具有同等法律效力。\n五、保密与合规：双方对在合作中知悉的对方商业秘密负有保密义务。',
  },
  {
    id: 2, name: '单笔采购合同', category: '单笔合同', signType: 1, validityMonths: 6, paymentDays: 60, settleDay: 20,
    amountDesc: '按单笔订单金额结算', enabled: true, updatedAt: '2026-07-12 14:20:00',
    variables: ['供应商名称', '采购方', '合同金额', '有效期', '账期'],
    content: '甲方（采购方）：{采购方}\n乙方（供应商）：{供应商名称}\n一、采购标的：详见附件订单清单，合同金额（含税）{合同金额}。\n二、合同有效期：{有效期}。\n三、结算与账期：账期 {账期} 天，到期货款凭合规发票支付。\n四、电子签署：本合同经第三方电子签名平台签署后生效，具备法律效力。',
  },
  {
    id: 3, name: '补充协议（框架协议变更）', category: '补充协议', signType: 2, validityMonths: 12, paymentDays: 30, settleDay: 25,
    amountDesc: '随主协议结算', enabled: true, updatedAt: '2026-07-15 09:30:00',
    variables: ['供应商名称', '主协议编号', '变更内容', '有效期'],
    content: '本协议为《供应商合作框架协议》（主协议编号：{主协议编号}）之补充协议，签约双方：{供应商名称} 与 安徽亿佳供应链集团有限公司。\n一、变更内容：{变更内容}。\n二、有效期：{有效期}。\n三、本协议与主协议具有同等法律效力，冲突部分以本协议为准。',
  },
  {
    id: 4, name: '保密与竞业限制协议', category: '专项协议', signType: 2, validityMonths: 24, paymentDays: 0, settleDay: 25,
    amountDesc: '无金额', enabled: true, updatedAt: '2026-07-08 16:00:00',
    variables: ['供应商名称', '有效期'],
    content: '甲方：安徽亿佳供应链集团有限公司\n乙方：{供应商名称}\n一、保密范围：双方在合作中交换的商务、技术、价格等信息均属保密信息。\n二、有效期：{有效期}。\n三、违约责责：任一方违反保密义务应承担相应法律责任。',
  },
  {
    id: 5, name: '质量保证协议', category: '专项协议', signType: 1, validityMonths: 12, paymentDays: 30, settleDay: 25,
    amountDesc: '无金额', enabled: false, updatedAt: '2026-06-30 11:00:00',
    variables: ['供应商名称', '有效期'],
    content: '甲方：安徽亿佳供应链集团有限公司\n乙方：{供应商名称}\n一、质量标准：乙方供货须符合国家标准及甲方验收规范。\n二、有效期：{有效期}。\n三、质量异议：甲方有权在收货后按约定时限提出质量异议。',
  },
  {
    id: 6, name: '物流服务协议', category: '专项协议', signType: 2, validityMonths: 12, paymentDays: 30, settleDay: 25,
    amountDesc: '按物流费用结算', enabled: true, updatedAt: '2026-07-18 15:40:00',
    variables: ['供应商名称', '配送范围', '有效期'],
    content: '甲方：安徽亿佳供应链集团有限公司\n乙方：{供应商名称}\n一、配送范围：{配送范围}。\n二、服务标准：乙方须保证时效与完好率。\n三、有效期：{有效期}。',
  },
]

/* ============ 合同管理（管理视角，完整生命周期，与用户侧规范对齐） ============ */
export const contracts = [
  {
    id: 1, contractNo: 'HT20260001', contractName: '兴业银行集采供应商合作框架协议', vendorId: 1, vendorName: '江苏佳诺云电子科技有限公司',
    projectName: '兴业银行集采', type: '框架协议', signType: 2,
    signStatus: '已签署完成', contractStatus: '生效中',
    startDate: '2026-01-01', endDate: '2026-12-31', paymentDays: 30, settleDay: 25, amount: '按订单结算',
    templateId: 1, templateName: '供应商合作框架协议（年度）',
    content: '年度框架合作协议，按实际订单月度结算，账期30天。',
    fileUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/tpl-frame.pdf',
    stampContractUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/ht1-stamp.pdf',
    doubleStampContractUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/ht1-double.pdf',
    importFile: '', isHistory: false,
    createdBy: '平台管理员', createdAt: '2025-12-20 10:00:00', initiatedAt: '2025-12-22 09:00:00',
    signedAt: '2026-01-05 10:00:00', esignProvider: '法大大', signTaskId: '', signUrl: '',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '', lastPaymentReminder: '',
    remark: '年度框架协议',
  },
  {
    id: 2, contractNo: 'HT20260002', contractName: '浦东发展银行办公用品采购合同', vendorId: 2, vendorName: '兰维乐（上海）食品有限公司',
    projectName: '浦东发展银行', type: '单笔合同', signType: 1,
    signStatus: '已签署完成', contractStatus: '生效中',
    startDate: '2026-03-01', endDate: '2026-08-10', paymentDays: 60, settleDay: 20, amount: '389050.00',
    templateId: 2, templateName: '单笔采购合同',
    content: '单笔采购合同，账期60天。',
    fileUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/tpl-buy.pdf',
    stampContractUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/ht2-stamp.pdf',
    doubleStampContractUrl: '',
    importFile: '', isHistory: false,
    createdBy: '平台管理员', createdAt: '2026-02-25 10:00:00', initiatedAt: '2026-02-26 09:00:00',
    signedAt: '2026-03-10 14:00:00', esignProvider: 'e签宝', signTaskId: '', signUrl: '',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '', lastPaymentReminder: '',
    remark: '',
  },
  {
    id: 3, contractNo: 'HT20260003', contractName: '联家商超供应链服务协议', vendorId: 4, vendorName: '得力集团有限公司',
    projectName: '联家', type: '框架协议', signType: 2,
    signStatus: '待对方签', contractStatus: '待签署',
    startDate: '2026-05-01', endDate: '2027-04-30', paymentDays: 30, settleDay: 25, amount: '按订单结算',
    templateId: 1, templateName: '供应商合作框架协议（年度）',
    content: '年度框架合作协议，待供应商用印。',
    fileUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/tpl-frame.pdf',
    stampContractUrl: '', doubleStampContractUrl: '', importFile: '', isHistory: false,
    createdBy: '平台管理员', createdAt: '2026-04-20 10:00:00', initiatedAt: '2026-04-22 09:00:00',
    signedAt: '', esignProvider: '法大大', signTaskId: 'ES20260422001', signUrl: 'https://fadada.esign-demo.com/sign?task=ES20260422001',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '', lastPaymentReminder: '',
    remark: '待供应商用印',
  },
  {
    id: 4, contractNo: 'HT20260004', contractName: '深圳齐心办公耗材供货合同', vendorId: 5, vendorName: '深圳齐心集团股份有限公司',
    projectName: '浦东发展银行', type: '单笔合同', signType: 1,
    signStatus: '已签署完成', contractStatus: '已到期',
    startDate: '2025-06-01', endDate: '2026-05-31', paymentDays: 30, settleDay: 25, amount: '125000.00',
    templateId: 2, templateName: '单笔采购合同',
    content: '单笔采购合同，已到期需续签。',
    fileUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/tpl-buy.pdf',
    stampContractUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/ht4-stamp.pdf',
    doubleStampContractUrl: '',
    importFile: '', isHistory: false,
    createdBy: '平台管理员', createdAt: '2025-05-20 10:00:00', initiatedAt: '2025-05-22 09:00:00',
    signedAt: '2025-06-05 09:00:00', esignProvider: '法大大', signTaskId: '', signUrl: '',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '2026-05-01 09:00:00', lastPaymentReminder: '',
    remark: '已到期，需续签',
  },
  {
    id: 5, contractNo: 'HT20250099', contractName: '历史纸质框架协议（补录）', vendorId: 1, vendorName: '江苏佳诺云电子科技有限公司',
    projectName: '中国建行集采云电商', type: '框架协议', signType: 2,
    signStatus: '已签署完成', contractStatus: '生效中',
    startDate: '2025-01-01', endDate: '2026-12-31', paymentDays: 30, settleDay: 25, amount: '按订单结算',
    templateId: 0, templateName: '线下纸质合同（补录）',
    content: '历史线下签署纸质合同，扫描件补录归档。',
    fileUrl: '', stampContractUrl: '', doubleStampContractUrl: '',
    importFile: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/ht5-history.pdf', isHistory: true,
    createdBy: '平台管理员', createdAt: '2026-07-20 10:00:00', initiatedAt: '', signedAt: '2025-01-10 09:00:00',
    esignProvider: '线下', signTaskId: '', signUrl: '',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '', lastPaymentReminder: '',
    remark: '供应商线下已盖章，平台补录归档，纳入到期提醒',
  },
  {
    id: 6, contractNo: 'HT20260005', contractName: '兰维乐冷链物流服务协议', vendorId: 2, vendorName: '兰维乐（上海）食品有限公司',
    projectName: '浦东发展银行', type: '专项协议', signType: 2,
    signStatus: '签署中', contractStatus: '签署中',
    startDate: '2026-07-01', endDate: '2027-06-30', paymentDays: 30, settleDay: 25, amount: '按物流费用结算',
    templateId: 6, templateName: '物流服务协议',
    content: '冷链物流服务协议，已发起电子签署，等待双方意愿认证。',
    fileUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/tpl-logistics.pdf',
    stampContractUrl: '', doubleStampContractUrl: '', importFile: '', isHistory: false,
    createdBy: '平台管理员', createdAt: '2026-07-21 10:00:00', initiatedAt: '2026-07-22 09:00:00',
    signedAt: '', esignProvider: 'e签宝', signTaskId: 'ES20260722005', signUrl: 'https://esign.esign-demo.com/sign?task=ES20260722005',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '', lastPaymentReminder: '',
    remark: '已发起电子签署，等待双方签署',
  },
]

/* ============ 供应商关停审批（管理视角，与用户侧 vendor/shutdown 对齐） ============ */
export const shutdowns = [
  { id: 1, vendorName: '深圳齐心集团股份有限公司', applyTime: '2026-07-22 09:30:00', shutdownTime: '2026-08-01 00:00:00', reason: '业务调整，暂停与平台的合作', status: '待审核', auditTime: '', auditReason: '' },
  { id: 2, vendorName: '上海晨光科力普办公用品有限公司', applyTime: '2026-07-18 15:00:00', shutdownTime: '2026-07-25 00:00:00', reason: '授权到期不再续签', status: '已驳回', auditTime: '2026-07-19 10:00:00', auditReason: '该供应商仍有在途订单，暂不可关停' },
  { id: 3, vendorName: '兰维乐（上海）食品有限公司', applyTime: '2026-06-30 11:00:00', shutdownTime: '2026-07-10 00:00:00', reason: '季节性调整', status: '已通过', auditTime: '2026-07-01 09:00:00', auditReason: '同意关停' },
]

/* ============ 发票管理（管理视角，与用户侧 finance/vendorInvoiceDownload + 对账单开票 对齐） ============ */
export const invoices = [
  { id: 1, invoiceNo: 'FP202607240001', shipId: 'S202607240001', purchaseOrderNo: 'PO202607200001', outOrderNo: 'C202607200001', vendorName: '江苏佳诺云电子科技有限公司', projectName: '兴业银行集采', invoiceAmount: '12580.00', invoiceType: '增值税专用发票', invoiceStatus: '待开票', invoiceTime: '', fileUrl: '', downloadStatus: '未下载' },
  { id: 2, invoiceNo: 'FP202607230002', shipId: 'S202607230002', purchaseOrderNo: 'PO202607180002', outOrderNo: 'C202607180002', vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行', invoiceAmount: '3890.50', invoiceType: '增值税专用发票', invoiceStatus: '已开票', invoiceTime: '2026-07-24 09:00:00', fileUrl: '', downloadStatus: '已下载' },
  { id: 3, invoiceNo: 'FP202607220003', shipId: 'S202607220003', purchaseOrderNo: 'PO202607150003', outOrderNo: 'C202607150003', vendorName: '得力集团有限公司', projectName: '兴业银行集采', invoiceAmount: '25600.00', invoiceType: '增值税普通发票', invoiceStatus: '已作废', invoiceTime: '2026-07-22 16:00:00', fileUrl: '', downloadStatus: '未下载' },
]

/* ============ 售后服务管理（管理视角，与用户侧 aftersale/asManageApply 对齐） ============ */
export const aftersales = [
  { id: 1, serviceNo: 'AS202607240001', orderNo: 'PO202607200001', projectName: '兴业银行集采', type: '退货', applicant: '张主任', applicantMobile: '13800001111', applyTime: '2026-07-24 10:00:00', finishTime: '', skuName: '联想 ThinkPad X1 笔记本', skuId: 'SKU001', skuCode: 'LX-X1-001', unitPrice: '8999.00', quantity: 2, paidAmount: '17998.00', actualRefundAmount: '17998.00', reason: '客户验收不通过，申请退货', receiver: '张主任', receiverMobile: '13800001111', receiverAddress: '上海市浦东新区浦东南路XX号', status: '待处理' },
  { id: 2, serviceNo: 'AS202607230002', orderNo: 'PO202607180002', projectName: '浦东发展银行', type: '换货', applicant: '李主管', applicantMobile: '13800002222', applyTime: '2026-07-23 09:00:00', finishTime: '2026-07-24 14:00:00', skuName: '兰维乐 矿泉水 360ml*24瓶', skuId: 'SKU002', skuCode: 'LW-KS-002', unitPrice: '39.90', quantity: 10, paidAmount: '399.00', actualRefundAmount: '0.00', reason: '包装破损，申请换货', receiver: '李主管', receiverMobile: '13800002222', receiverAddress: '上海市徐汇区虹桥路XX号', status: '已完成' },
  { id: 3, serviceNo: 'AS202607220003', orderNo: 'PO202607150003', projectName: '兴业银行集采', type: '退货', applicant: '王经理', applicantMobile: '13800003333', applyTime: '2026-07-22 08:00:00', finishTime: '', skuName: '得力 A4 复印纸 70g', skuId: 'SKU003', skuCode: 'DL-PP-003', unitPrice: '25.00', quantity: 50, paidAmount: '1250.00', actualRefundAmount: '1250.00', reason: '非质量问题，客户原因退货', receiver: '王经理', receiverMobile: '13800003333', receiverAddress: '上海市浦东新区浦东南路XX号', status: '已拒绝' },
]

/* ============ 采购竞价管理（管理视角，与用户侧 bidding/purchaseBiddingManage 对齐） ============ */
export const biddings = [
  { id: 1, biddingNo: 'BJ202607240001', outBiddingNo: 'WB202607240001', goodsName: '联想 ThinkPad X1 笔记本', projectName: '兴业银行集采', goodsCount: 200, startPrice: '8999.00', deadline: '2026-07-28 18:00:00', openTime: '2026-07-25 09:00:00', image: '', address: '上海市浦东新区', status: '进行中', owner: '', quoteCount: 0, supplierCount: 0 },
  { id: 2, biddingNo: 'BJ202607230002', outBiddingNo: 'WB202607230002', goodsName: '得力 A4 复印纸 70g', projectName: '浦东发展银行', goodsCount: 5000, startPrice: '25.00', deadline: '2026-07-26 18:00:00', openTime: '2026-07-24 09:00:00', image: '', address: '上海市徐汇区', status: '进行中', owner: '运营-小李', quoteCount: 3, supplierCount: 2 },
  { id: 3, biddingNo: 'BJ202607200003', outBiddingNo: 'WB202607200003', goodsName: '兰维乐 矿泉水 360ml*24', projectName: '联家', goodsCount: 10000, startPrice: '39.90', deadline: '2026-07-22 18:00:00', openTime: '2026-07-21 09:00:00', image: '', address: '上海市浦东新区', status: '已结束', owner: '运营-小王', quoteCount: 8, supplierCount: 5 },
]

/* ============ 询价单管理（管理视角，与用户侧 bidding/inquirySheetManage 对齐） ============ */
export const inquiries = [
  { id: 1, inquiryNo: 'XJ202607240001', projectName: '浦发银行', inquiryType: '普通询价', itemCount: 36, deadline: '2026-07-28 18:00:00', feedbackTime: '2026-07-29 12:00:00', status: '待报价', assignedVendor: '', quoteCount: 0 },
  { id: 2, inquiryNo: 'XJ202607230002', projectName: '联家', inquiryType: '紧急询价', itemCount: 12, deadline: '2026-07-25 12:00:00', feedbackTime: '2026-07-25 18:00:00', status: '已报价', assignedVendor: '得力集团有限公司', quoteCount: 1 },
  { id: 3, inquiryNo: 'XJ202607200003', projectName: '京东', inquiryType: '普通询价', itemCount: 50, deadline: '2026-07-21 18:00:00', feedbackTime: '2026-07-22 12:00:00', status: '已截止', assignedVendor: '兰维乐（上海）食品有限公司', quoteCount: 2 },
]

/* ============ 消息中心（管理端接收各模块待办/告警/通知） ============ */
export const messages = [
  { id: 1, title: '商品审核待办', content: '兰维乐 矿泉水 360ml*24瓶 等待商品初审', type: '待办', module: '商品', relatedPath: '/product/audit', time: '2026-07-25 09:30:00', read: false },
  { id: 2, title: '报备订单待审核', content: '浦东发展银行 报备订单 RB202607240001 等待审核', type: '待办', module: '订单', relatedPath: '/order/report', time: '2026-07-25 09:10:00', read: false },
  { id: 3, title: '资质授权待审核', content: '江苏佳诺云电子科技有限公司 联想品牌授权 待审核', type: '待办', module: '供应商', relatedPath: '/vendor/qualification-audit', time: '2026-07-25 08:50:00', read: false },
  { id: 4, title: '供应商关停申请', content: '深圳齐心集团股份有限公司 申请关停，待平台审核', type: '告警', module: '供应商', relatedPath: '/vendor/shutdown-audit', time: '2026-07-24 18:00:00', read: false },
  { id: 5, title: '反采申请待审核', content: '兰维乐 反采申请 FC202607230001 等待审核', type: '待办', module: '订单', relatedPath: '/order/reverse', time: '2026-07-24 15:00:00', read: true },
]

/* ============ 管理端角色权限（8 个预置角色，key 驱动菜单/权限/数据范围） ============ */
export const roles = [
  { id: 1, key: 'super_admin', name: '超级管理员', type: 'preset', isLocked: true, adminLevel: 100, menuPaths: ['/dashboard', '/ai', '/vendor', '/product', '/order', '/bidding', '/finance', '/aftersale', '/service', '/guide', '/exception', '/voucher', '/help', '/system', '/logs'], dataScope: 'all', description: '系统最高权限，内置唯一，不可增删，仅可自改基本信息与密码' },
  { id: 2, key: 'sys_admin', name: '系统管理员', type: 'preset', isLocked: true, adminLevel: 90, menuPaths: ['/dashboard', '/ai', '/vendor', '/product', '/order', '/bidding', '/finance', '/aftersale', '/service', '/guide', '/exception', '/voucher', '/help', '/system'], dataScope: 'all', description: '日常账号/角色/菜单维护，可被超管停用，不可停用同级' },
  { id: 3, key: 'operator', name: '操作员', type: 'preset', isLocked: true, adminLevel: 70, menuPaths: ['/dashboard', '/vendor', '/product', '/order', '/bidding', '/finance', '/aftersale', '/service', '/exception'], dataScope: 'all', description: '商品/订单/竞价/财务/售后等日常运营操作' },
  { id: 4, key: 'finance', name: '财务专员', type: 'preset', isLocked: true, adminLevel: 70, menuPaths: ['/dashboard', '/vendor', '/order', '/finance', '/exception', '/voucher', '/logs'], dataScope: 'finance', description: '对账/发票/结算，数据范围限定财务域' },
  { id: 5, key: 'cs_manager', name: '客服主管', type: 'preset', isLocked: true, adminLevel: 60, menuPaths: ['/dashboard', '/ai', '/vendor', '/order', '/aftersale', '/service', '/exception'], dataScope: 'team', description: '客服团队管理、排班与审批，数据范围团队' },
  { id: 6, key: 'cs', name: '客服专员', type: 'preset', isLocked: true, adminLevel: 40, menuPaths: ['/dashboard', '/ai', '/vendor', '/order', '/aftersale', '/service', '/exception'], dataScope: 'self', description: '客服接待与工单处理，数据范围仅自己' },
  { id: 7, key: 'content', name: '内容运营', type: 'preset', isLocked: true, adminLevel: 60, menuPaths: ['/dashboard', '/ai', '/vendor', '/product', '/order', '/bidding', '/finance', '/aftersale', '/guide', '/help'], dataScope: 'content', description: '帮助中心/页面引导等内容运营，数据范围内容域' },
  { id: 8, key: 'auditor', name: '审计员', type: 'preset', isLocked: true, adminLevel: 65, menuPaths: ['/dashboard', '/vendor', '/product', '/order', '/bidding', '/finance', '/aftersale', '/service', '/guide', '/exception', '/voucher', '/help', '/logs'], dataScope: 'readonly', description: '只读审计，查看全模块与操作日志' },
]

/* ============ 管理端账号（与角色一一对应，Mock 明文，上线需后端加密） ============ */
export const accounts = [
  { id: 1, account: 'admin', password: '123456', name: '超级管理员', roleKey: 'super_admin', roleName: '超级管理员', adminLevel: 100, status: 'enabled', phone: '13800000000', email: 'admin@yijia.com', dataScope: 'all', isProtected: true, createdAt: '2026-01-01 00:00:00' },
  { id: 2, account: 'sysadmin', password: 'sys@6688', name: '系统管理员', roleKey: 'sys_admin', roleName: '系统管理员', adminLevel: 90, status: 'enabled', phone: '13800000001', email: 'sysadmin@yijia.com', dataScope: 'all', isProtected: false, createdAt: '2026-01-02 00:00:00' },
  { id: 3, account: 'operator', password: 'ops@3344', name: '运营操作员', roleKey: 'operator', roleName: '操作员', adminLevel: 70, status: 'enabled', phone: '13800000002', email: 'operator@yijia.com', dataScope: 'all', isProtected: false, createdAt: '2026-01-03 00:00:00' },
  { id: 4, account: 'finance', password: 'fin@5566', name: '财务专员', roleKey: 'finance', roleName: '财务专员', adminLevel: 70, status: 'enabled', phone: '13800000003', email: 'finance@yijia.com', dataScope: 'finance', isProtected: false, createdAt: '2026-01-04 00:00:00' },
  { id: 5, account: 'csmanager', password: 'csm@7788', name: '客服主管', roleKey: 'cs_manager', roleName: '客服主管', adminLevel: 60, status: 'enabled', phone: '13800000004', email: 'csmanager@yijia.com', dataScope: 'team', isProtected: false, createdAt: '2026-01-05 00:00:00' },
  { id: 6, account: 'csstaff', password: 'css@1122', name: '客服专员', roleKey: 'cs', roleName: '客服专员', adminLevel: 40, status: 'enabled', phone: '13800000005', email: 'csstaff@yijia.com', dataScope: 'self', isProtected: false, createdAt: '2026-01-06 00:00:00' },
  { id: 7, account: 'content', password: 'con@9900', name: '内容运营', roleKey: 'content', roleName: '内容运营', adminLevel: 60, status: 'enabled', phone: '13800000006', email: 'content@yijia.com', dataScope: 'content', isProtected: false, createdAt: '2026-01-07 00:00:00' },
  { id: 8, account: 'auditor', password: 'aud@2211', name: '审计员', roleKey: 'auditor', roleName: '审计员', adminLevel: 65, status: 'enabled', phone: '13800000007', email: 'auditor@yijia.com', dataScope: 'readonly', isProtected: false, createdAt: '2026-01-08 00:00:00' },
]

/* ============ 品牌人格化配置（原则1：小亿，后台可配置，默认值小亿） ============ */
export const brandConfig = {
  personaName: '小亿',
  options: ['小亿', '小亿助手', '亿佳小蜜', '亿佳助手', '佳佳'],
}

/* ============ 客服系统（M1）：客服档案 / 排班 / 分配日志 / 轮询策略 ============ */

/* 业务线枚举（与轮询池、排班冲突检测绑定） */
export const SERVICE_LINES = [
  { value: 'recon', label: '对账' },
  { value: 'order', label: '订单' },
  { value: 'contract', label: '合同' },
  { value: 'goods', label: '商品' },
  { value: 'general', label: '综合' },
]

/* 客服等级枚举 */
export const SERVICE_LEVELS = [
  { value: 'normal', label: '普通' },
  { value: 'senior', label: '资深' },
  { value: 'lead', label: '主管' },
]

/* 客服状态枚举 */
export const SERVICE_STATUS = [
  { value: 'enabled', label: '启用' },
  { value: 'disabled', label: '停用' },
  { value: 'leave', label: '请假' },
]

/* 班次类型枚举 */
export const SERVICE_SHIFTS = [
  { value: 'fullday', label: '全天' },
  { value: 'am', label: '上午' },
  { value: 'pm', label: '下午' },
  { value: 'hour', label: '小时' },
]

/* 根据今天计算本周一 ~ 周日（yyyy-MM-dd），排班种子按当前周生成 */
function weekDates() {
  const d = new Date()
  const day = d.getDay() === 0 ? 7 : d.getDay() // 周一=1
  const monday = new Date(d)
  monday.setDate(d.getDate() - (day - 1))
  const fmt = n => String(n).padStart(2, '0')
  const ds = []
  for (let i = 0; i < 7; i++) {
    const x = new Date(monday)
    x.setDate(monday.getDate() + i)
    ds.push(`${x.getFullYear()}-${fmt(x.getMonth() + 1)}-${fmt(x.getDate())}`)
  }
  return ds
}
const WEEK = weekDates()

/* 客服人员档案（11 字段，含二维码/头像 base64 占位由组件生成） */
export const serviceAgents = [
  { id: 1, name: '严芳芳', workNo: 'CS001', phone: '13800003001', line: 'recon', level: 'lead', status: 'enabled', qrcodeImg: '', avatar: '', dailyLimit: 60, todayCount: 12 },
  { id: 2, name: '李娜', workNo: 'CS002', phone: '13800003002', line: 'recon', level: 'senior', status: 'enabled', qrcodeImg: '', avatar: '', dailyLimit: 50, todayCount: 8 },
  { id: 3, name: '王敏', workNo: 'CS003', phone: '13800003003', line: 'order', level: 'normal', status: 'enabled', qrcodeImg: '', avatar: '', dailyLimit: 50, todayCount: 15 },
  { id: 4, name: '张伟', workNo: 'CS004', phone: '13800003004', line: 'order', level: 'senior', status: 'enabled', qrcodeImg: '', avatar: '', dailyLimit: 50, todayCount: 5 },
  { id: 5, name: '陈静', workNo: 'CS005', phone: '13800003005', line: 'contract', level: 'normal', status: 'enabled', qrcodeImg: '', avatar: '', dailyLimit: 40, todayCount: 3 },
  { id: 6, name: '刘洋', workNo: 'CS006', phone: '13800003006', line: 'goods', level: 'normal', status: 'enabled', qrcodeImg: '', avatar: '', dailyLimit: 40, todayCount: 9 },
  { id: 7, name: '赵磊', workNo: 'CS007', phone: '13800003007', line: 'general', level: 'senior', status: 'disabled', qrcodeImg: '', avatar: '', dailyLimit: 40, todayCount: 0 },
  { id: 8, name: '孙琳', workNo: 'CS008', phone: '13800003008', line: 'recon', level: 'normal', status: 'leave', qrcodeImg: '', avatar: '', dailyLimit: 50, todayCount: 0 },
]

/* 排班种子（本周：每个启用客服排若干天；含一条换班待审批 + 一条请假） */
export const serviceSchedules = [
  // 严芳芳(对账/主管)：周一~周五 全天
  { id: 1, agentId: 1, date: WEEK[0], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 2, agentId: 1, date: WEEK[1], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 3, agentId: 1, date: WEEK[2], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 4, agentId: 1, date: WEEK[3], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 5, agentId: 1, date: WEEK[4], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  // 李娜(对账/资深)：周一~周四 上午、周五 下午
  { id: 6, agentId: 2, date: WEEK[0], shift: 'am', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 7, agentId: 2, date: WEEK[1], shift: 'am', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 8, agentId: 2, date: WEEK[2], shift: 'am', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 9, agentId: 2, date: WEEK[3], shift: 'am', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 10, agentId: 2, date: WEEK[4], shift: 'pm', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  // 王敏(订单)：周一~周五 全天
  { id: 11, agentId: 3, date: WEEK[0], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 12, agentId: 3, date: WEEK[1], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 13, agentId: 3, date: WEEK[2], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 14, agentId: 3, date: WEEK[3], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 15, agentId: 3, date: WEEK[4], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  // 张伟(订单/资深)：周二~周六 全天（周一休息 → 周一订单线仅王敏，触发冲突告警）
  { id: 16, agentId: 4, date: WEEK[1], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 17, agentId: 4, date: WEEK[2], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 18, agentId: 4, date: WEEK[3], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 19, agentId: 4, date: WEEK[4], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 20, agentId: 4, date: WEEK[5], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  // 陈静(合同)：周一~周五 上午
  { id: 21, agentId: 5, date: WEEK[0], shift: 'am', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 22, agentId: 5, date: WEEK[1], shift: 'am', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 23, agentId: 5, date: WEEK[2], shift: 'am', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 24, agentId: 5, date: WEEK[3], shift: 'am', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 25, agentId: 5, date: WEEK[4], shift: 'am', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  // 刘洋(商品)：周一~周五 全天
  { id: 26, agentId: 6, date: WEEK[0], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 27, agentId: 6, date: WEEK[1], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 28, agentId: 6, date: WEEK[2], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 29, agentId: 6, date: WEEK[3], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  { id: 30, agentId: 6, date: WEEK[4], shift: 'fullday', status: 'normal', swapWith: null, swapStatus: '', leaveReason: '' },
  // 孙琳(综合/停用)：无排班
  // 赵磊(对账/请假)：周一~周三 请假（自动从排班池剔除）
  { id: 31, agentId: 8, date: WEEK[0], shift: 'fullday', status: 'leave', swapWith: null, swapStatus: '', leaveReason: '病假' },
  { id: 32, agentId: 8, date: WEEK[1], shift: 'fullday', status: 'leave', swapWith: null, swapStatus: '', leaveReason: '病假' },
  { id: 33, agentId: 8, date: WEEK[2], shift: 'fullday', status: 'leave', swapWith: null, swapStatus: '', leaveReason: '病假' },
  // 换班申请：张伟(WEEK[5] 周六) 申请与 王敏 互换
  { id: 34, agentId: 4, date: WEEK[5], shift: 'fullday', status: 'swapped', swapWith: 3, swapStatus: 'pending', leaveReason: '' },
]

/* 分配日志（用户侧扫码联系记录，含隐形水印标记） */
export const serviceAssignLogs = [
  { id: 1, vendorId: 1, vendorName: '江苏佳诺云电子科技有限公司', agentId: 1, agentName: '严芳芳', line: 'recon', triggerPos: 'recon_list', assignTime: '2026-07-26 09:12:00', bindExpire: '2026-07-26 09:42:00', watermarkFlag: 1 },
  { id: 2, vendorId: 3, vendorName: '上海晨光科力普办公用品有限公司', agentId: 2, agentName: '李娜', line: 'recon', triggerPos: 'order_detail', assignTime: '2026-07-26 10:05:00', bindExpire: '2026-07-26 10:35:00', watermarkFlag: 1 },
  { id: 3, vendorId: 1, vendorName: '江苏佳诺云电子科技有限公司', agentId: 3, agentName: '王敏', line: 'order', triggerPos: 'float', assignTime: '2026-07-26 11:20:00', bindExpire: '2026-07-26 11:50:00', watermarkFlag: 1 },
  { id: 4, vendorId: 5, vendorName: '深圳齐心集团股份有限公司', agentId: 4, agentName: '张伟', line: 'order', triggerPos: 'recon_list', assignTime: '2026-07-26 14:08:00', bindExpire: '2026-07-26 14:38:00', watermarkFlag: 1 },
]

/* 轮询策略配置（原则：最少接待优先；bind_expire 默认 30min；换一个排除当前人） */
export const serviceConfig = {
  algorithm: 'least', // least | round | weighted
  bindExpire: 30, // 分钟
  excludeCurrent: true, // 换一个客服时排除当前人
  maxPerSlot: 4, // 同时段同业务线最多人数（超上限黄色告警）
}

/* ============ 帮助中心（M2）：分类 / 文章 / 反馈（原则3：内容运营自助化） ============ */
export const helpCategories = [
  { id: 1, name: '公告', parentId: 0, sort: 1, status: 'enabled' },
  { id: 2, name: '通知', parentId: 0, sort: 2, status: 'enabled' },
  { id: 3, name: '学习中心', parentId: 0, sort: 3, status: 'enabled' },
  { id: 4, name: '操作手册', parentId: 0, sort: 4, status: 'enabled' },
  { id: 5, name: '如何对账', parentId: 4, sort: 1, status: 'enabled' },
  { id: 6, name: '商品上架', parentId: 4, sort: 2, status: 'enabled' },
]

export const helpArticles = [
  { id: 1, catId: 1, title: '关于2026年第三季度对账周期调整的通知', summary: '本季度对账周期统一调整为自然月，请各供应商留意结算时间。', body: '## 调整背景\n为提升对账效率，平台自2026年第三季度起将对账周期统一调整为自然月。\n\n## 具体安排\n- 每月1日生成上月对账单；\n- 每月5日前供应商完成确认；\n- 每月10日前完成开票与结算。\n\n## 影响范围\n所有有效供应商均适用本通知。', cover: '', status: 'published', top: 1, publishAt: '2026-07-01 09:00:00', pv: 320, uv: 210, author: '小亿', operator: '内容运营', createdAt: '2026-07-01 08:30:00', updatedAt: '2026-07-01 09:00:00' },
  { id: 2, catId: 5, title: '如何完成对账与开票（供应商图文指引）', summary: '一步一步教你对账、确认、提交发票的全过程。', body: '## 进入对账页\n登录后点击左侧「对账财务 → 供应商对账单」。\n\n## 确认对账单\n核对金额无误后点击「维护发票」。\n\n### 提交发票\n上传发票信息并提交审核。\n\n## 常见问题\n若金额不符，请先发起异常工单。', cover: '', status: 'published', top: 0, publishAt: '2026-07-10 10:00:00', pv: 512, uv: 380, author: '小亿', operator: '内容运营', createdAt: '2026-07-10 09:00:00', updatedAt: '2026-07-12 14:00:00' },
  { id: 3, catId: 3, title: '供应商入驻资质要求说明', summary: '介绍入驻所需资质、证照与审核流程。', body: '## 基础资质\n营业执照、开户许可、开票资料。\n\n## 专项资质\n根据经营类目提供对应资质。', cover: '', status: 'published', top: 0, publishAt: '2026-06-20 11:00:00', pv: 180, uv: 120, author: '小亿', operator: '系统管理员', createdAt: '2026-06-20 10:00:00', updatedAt: '2026-06-20 11:00:00' },
  { id: 4, catId: 2, title: '系统维护停机预告（草稿示例）', summary: '本周末将对消息中心进行升级。', body: '## 维护时间\n本周六 22:00 - 周日 02:00。\n\n## 影响\n期间消息推送可能延迟。', cover: '', status: 'draft', top: 0, publishAt: '', pv: 0, uv: 0, author: '小亿', operator: '内容运营', createdAt: '2026-07-25 16:00:00', updatedAt: '2026-07-25 16:00:00' },
]

export const helpFeedbacks = [
  { id: 1, articleId: 2, vote: 'up', text: '', vendorId: 1, createdAt: '2026-07-15 10:12:00' },
  { id: 2, articleId: 2, vote: 'up', text: '很清晰，谢谢', vendorId: 2, createdAt: '2026-07-16 09:30:00' },
  { id: 3, articleId: 2, vote: 'down', text: '第三步不太明白', vendorId: 3, createdAt: '2026-07-18 14:20:00' },
  { id: 4, articleId: 1, vote: 'up', text: '', vendorId: 4, createdAt: '2026-07-20 11:05:00' },
]

/* ============ M3 页面引导配置（原则3 内容运营自助化；竞品 #如何对账? 式贴身提示） ============ */
export const guideConfigs = [
  { id: 1, route: '/zq/purchase/vendor-zq-purchase-order', title: '如何对账?', type: 'guide', content: '## 如何对账\n1. 进入「对账管理」下载本月对账单。\n2. 核对金额与订单实收是否一致。\n3. 如有差异，点击页面右上角「联系小亿对账人员」。\n4. 确认无误后维护发票并确认对账。', visibleRule: 'all', status: 'enabled', sort: 1, createdAt: '2026-07-01 09:00:00', updatedAt: '2026-07-10 09:00:00', linkArticleId: 2 },
  { id: 2, route: '/zq/purchase/vendor-zq-purchase-order', title: '发版与签收流程?', type: 'guide', content: '## 发版与签收流程\n1. 商品发货后，等待物流签收。\n2. 在订单详情上传**签收凭证**图片。\n3. 财务审核通过后，签收状态确认。\n4. 详见帮助中心《签收凭证上传指引》。', visibleRule: 'newbie', status: 'enabled', sort: 2, createdAt: '2026-07-02 09:00:00', updatedAt: '2026-07-11 09:00:00', linkArticleId: 1 },
  { id: 3, route: '/supplier-bill-sup', title: '账期规则?', type: 'rule', content: '## 账期规则\n- 每月 25 日为对账截止日。\n- 账期 T+1 结算，遇节假日顺延。\n- 超期未开票将生成结算异常工单。', visibleRule: 'all', status: 'enabled', sort: 1, createdAt: '2026-07-03 09:00:00', updatedAt: '2026-07-12 09:00:00', linkArticleId: null },
  { id: 4, route: '/dashboard', title: '遇到问题联系谁?', type: 'contact', content: '如需帮助，可随时点击右下角浮标联系「小亿」在线客服。', visibleRule: 'lowfreq', status: 'enabled', sort: 1, createdAt: '2026-07-04 09:00:00', updatedAt: '2026-07-13 09:00:00', linkArticleId: null },
]

/* ============ M4 结算异常工单（原则4 异常工单化；状态机 + SLA + 分派 + 关单 + 复盘） ============ */
// 分类字典（原则2 可配置雏形）
export const exceptionTypes = ['金额不一致', '退货未冲账', '票号重号', '跨期', '超期未开票', '其他']
// 各类型默认 SLA（小时）
export const exceptionSla = { '金额不一致': 24, '退货未冲账': 48, '票号重号': 12, '跨期': 24, '超期未开票': 72, '其他': 48 }
export const exceptionTickets = [
  { id: 1, code: 'EX20260801-001', type: '金额不一致', refType: 'reconcile', refId: 'BILL-2026-07-003', vendorId: 1, vendorName: '合肥鑫源办公', title: '7月对账单金额与实收差 ¥1,280', desc: '对账单汇总 128,000，银行实收 126,720，差额 ¥1,280 待核查。', status: '待分派', assignee: '', slaDue: '2026-08-02 09:00:00', createdBy: 'system', createdAt: '2026-08-01 09:00:00', closedAt: '', reviewNote: '', replayNote: '' },
  { id: 2, code: 'EX20260801-002', type: '票号重号', refType: 'invoice', refId: 'INV-2026-07-118', vendorId: 2, vendorName: '芜湖恒达文具', title: '两张发票票号重复 FP202607118', desc: '发票 INV-2026-07-118 与 INV-2026-07-119 出现票号重号。', status: '处理中', assignee: 'finance', slaDue: '2026-08-01 21:00:00', createdBy: 'finance', createdAt: '2026-08-01 09:10:00', closedAt: '', reviewNote: '已联系供应商作废重开', replayNote: '' },
  { id: 3, code: 'EX20260720-014', type: '超期未开票', refType: 'order', refId: 'PO-2026-06-882', vendorId: 3, vendorName: '马鞍山诚达', title: '订单 PO-2026-06-882 超 30 天未开票', desc: '收货完成于 2026-06-22，截至今日仍未收到发票。', status: '已关单', assignee: 'finance', slaDue: '2026-07-23 09:00:00', createdBy: 'operator', createdAt: '2026-07-20 14:00:00', closedAt: '2026-07-22 10:30:00', reviewNote: '供应商已补开，订单状态回写正常', replayNote: '供应商开票及时率偏低，建议纳入月度复盘' },
  { id: 4, code: 'EX20260802-003', type: '退货未冲账', refType: 'order', refId: 'PO-2026-07-551', vendorId: 4, vendorName: '铜陵华荣', title: '退货单 RMA-2026-07-551 未冲账', desc: '7月退货 ¥3,600 已入库但未在账单冲减。', status: '待确认', assignee: 'finance', slaDue: '2026-08-03 09:00:00', createdBy: 'cs', createdAt: '2026-08-02 11:20:00', closedAt: '', reviewNote: '冲账完成，待复核确认', replayNote: '' },
]

/* ============ M5 签收凭证审核（原则4 审核工单化；待审/通过/驳回 + 回写签收异常） ============ */
// 占位凭证图（上线接 OSS + 哈希防篡改）
const VOUCHER_PLACEHOLDER = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120"><rect width="120" height="120" fill="#f5f7fa"/><text x="60" y="66" font-size="14" text-anchor="middle" fill="#909399">签收凭证</text></svg>')
export const voucherReviews = [
  { id: 1, orderId: 'PO-2026-07-901', vendorId: 1, vendorName: '合肥鑫源办公', imgList: [VOUCHER_PLACEHOLDER], status: '待审', reviewer: '', rejectReason: '', rejectTemplate: '', uploadedBy: '供应商', uploadedAt: '2026-08-18 15:20:00', reviewedAt: '' },
  { id: 2, orderId: 'PO-2026-07-902', vendorId: 2, vendorName: '芜湖恒达文具', imgList: [VOUCHER_PLACEHOLDER], status: '通过', reviewer: 'finance', rejectReason: '', rejectTemplate: '', uploadedBy: '供应商', uploadedAt: '2026-08-16 10:00:00', reviewedAt: '2026-08-17 09:30:00' },
  { id: 3, orderId: 'PO-2026-07-903', vendorId: 3, vendorName: '马鞍山诚达', imgList: [VOUCHER_PLACEHOLDER], status: '驳回', reviewer: 'finance', rejectReason: '签章不清晰，无法辨认收货章', rejectTemplate: '图片不清', uploadedBy: '供应商', uploadedAt: '2026-08-15 09:00:00', reviewedAt: '2026-08-15 14:00:00' },
  { id: 4, orderId: 'PO-2026-07-904', vendorId: 4, vendorName: '铜陵华荣', imgList: [VOUCHER_PLACEHOLDER], status: '待审', reviewer: '', rejectReason: '', rejectTemplate: '', uploadedBy: '供应商', uploadedAt: '2026-08-19 11:10:00', reviewedAt: '' },
]
